import axios from "../../axiosClient";

export const getMotionTrafficData = async (
  blockCode: any,
  chartType: any,
  location: any,
  signal: any
) => {
  const res = await axios.get(
    `/slpapp/Dashboard/getMotionTrafficDataByBlockCode/`,
    { params: { blockCode, chartType, location }, signal }
  );

  return res?.data;
};

export const getMotionTrafficDataByBlockCodeWithLevelOrLocation = async (
  blockCode: any,
  chartType: any,
  location: any,
  locationtype: any,
  signal: any
) => {
  const res = await axios.get(
    `/slpapp/Dashboard/getMotionTrafficDataByBlockCodeWithLevelOrLocation/`,
    {
      params: {
        blockCode,
        chartType,
        location,
        locationtype,
      },
      signal,
      paramsSerializer: {
        encode: (param: string) => encodeURIComponent(param),
      },
    }
  );

  return res?.data;
};
